import type React from 'react';
import type { SearchClient } from 'algoliasearch';
import type { InstantSearchServerState } from 'react-instantsearch-core';
import Hero from './Header/Hero/Hero';
import Container from './Container/Container';
import Navigation from './Header/Navigation/FaqNavigation';
import TranslationProvider from '../../../general/Translation/TranslationProvider';
import SsrRouter from '../../../general/Router/SsrRouter';
import InViewContextProvider from '../Context/InViewContextProvider';
import Translation from '../../../general/Translation/Translation';
import Section from '../../../general/Section/Section';
import WebshopContextProvider from '../../../general/WebshopContext/WebshopContextProvider';
import AlgoliaProvider from '../../general/InstantSearch/AlgoliaProvider';
import GiftyInline from './Container/Results/Gifty/GiftyInline';
import Search from './Header/Search/Search';
import type { AlgoliaFaqData } from '../../../../ssr/src/Outlet/AlgoliaFaqPage/AlgoliaFaqSchema';

interface Props {
  algoliaServerState?: InstantSearchServerState;
  faqData: AlgoliaFaqData;
  searchClient: SearchClient;
}

const App: React.FC<Props> = ({
  algoliaServerState,
  faqData,
  searchClient,
}) => {
  const {
    bankDetail,
    categories,
    contactInfo,
    contextData,
    faqIndexName,
    faqUri,
    translations,
  } = faqData;

  return (
    <WebshopContextProvider data={contextData}>
      <SsrRouter>
        <TranslationProvider dictionary={translations}>
          <AlgoliaProvider
            algoliaSearchClient={searchClient}
            indexName={faqIndexName}
            algoliaServerState={algoliaServerState}
          >
            <main className="faq-page">
              <Hero />
              <InViewContextProvider>
                <GiftyInline />
                <Section isXl>
                  <div className="page-heading is-centered">
                    <h2 className="h3">
                      <Translation
                        pageString="class.bestelstatus"
                        stringId="veelgestelde_vragen"
                      />
                    </h2>
                  </div>
                </Section>
                <Search />
                <Navigation
                  categories={categories}
                  faqUri={faqUri}
                />
                <Container
                  contactInfo={contactInfo}
                  categories={categories}
                  faqUri={faqUri}
                  bankDetail={bankDetail}
                />
              </InViewContextProvider>
            </main>
          </AlgoliaProvider>
        </TranslationProvider>
      </SsrRouter>
    </WebshopContextProvider>
  );
};

export default App;
